<template>

  <div>



    <v-container v-if="active">

      <v-col cols="12" sm="12" md="12" lg="12" class="text-center" v-if="loading">
        <v-progress-circular indeterminate color="grey darken-3" size="64"></v-progress-circular>
      </v-col>

    </v-container>


    <v-card v-if="!active" class="mx-auto my-12 pa-6" max-width="600" outlined>
      <v-container>
        <v-row justify="center" class="mb-4">
          <v-col cols="12" class="text-center">
            <v-icon color="error" large>mdi-alert-circle-outline</v-icon>
            <h2 class="mt-2">Usuario no encontrado</h2>
            <p>Este perfil no existe o ha sido desactivado.</p>
          </v-col>
        </v-row>

        <v-row justify="center" class="text-center">
          <v-col cols="12" sm="6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" block v-bind="attrs" v-on="on" @click="$router.push('/perfiles')">
                  <v-icon left>mdi-account-group</v-icon>
                  Ver Perfiles Públicos
                </v-btn>
              </template>
              <span>Explora los perfiles disponibles públicamente</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="success" block v-bind="attrs" v-on="on" @click="$router.push('/register_public')">
                  <v-icon left>mdi-account-plus</v-icon>
                  Crear Nuevo Usuario
                </v-btn>
              </template>
              <span>Registra un nuevo perfil, puede ser de URL privada o pública</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-card>


    <v-card v-if="!loading">



      <v-row>
        <!-- Columna para la imagen -->
        <v-col cols="12" sm="12" md="3" lg="3" class="d-flex justify-center">
          <v-avatar size="20vh" class="ma-0">
            <a data-fancybox data-caption="Single image"
              :href="server_url + 'api/principal/get_image/' + principal.identificador + '/' + principal.linkPhoto">
              <img :src="server_url + 'api/principal/get_image/' + principal.identificador + '/' + principal.linkPhoto" :style="{
                height: '20vh',
                transform: 'scale(' + this.principal.zoom / 50 + ') translate(' + principal.fotox + 'px,' + principal.fotoy + 'px)',
                transition: 'transform 0.2s'
              }" />
            </a>
          </v-avatar>
        </v-col>

        <!-- Columna para el texto -->
        <v-col cols="12" sm="7" lg="9" align-self="center">
          <v-card-title :style="{
            fontSize: '20px',   /* Tamaño */
            fontWeight: '500',   /* Peso */
            letterSpacing: '-.015625em', /* Espaciado */
            /* marginBottom: active ? '-1rem' : '0', /* Margen dinámico */
            color: principal.color
          }" class="mt-0 pt-0  mb-0">{{ principal.nombre }} {{ principal.apellido }}</v-card-title>

          <v-card-title :style="{
            fontSize: '15px',   /* Tamaño */
            fontWeight: '500',   /* Peso */
            letterSpacing: '-.015625em', /* Espaciado */
            /*   marginBottom: active ? '-1rem' : '0', /* Margen dinámico    grey--text en la parte de class de abajo*/
            color: principal.color
          }" class="mt-0 pt-0   mb-1">{{ principal.descripcion }}</v-card-title>

          <v-divider class="mx-4" :style="{ backgroundColor: principal.color }"></v-divider>
        </v-col>
      </v-row>








      <v-container>
        <v-row d-flex flex-no-wrap>




          <!-- <v-col cols="12">
          max-width="400" 

           class="ml-2 mt-5"
                    outlined
                    rounded
        </v-col> -->



          <v-col v-for="opcion in opcions" :key="opcion.id" cols="12" sm="12" lg="6">
            <v-card :color="opcion.color" dark>

              <!-- justify="space-between"     no-gutters                   align="center" align-content="center"     d-flex        flex-no-wrap       justify-space-between  -->
              <template>
                <v-container>
                  <v-row no-gutters>
                    <v-col cols="3" sm="3" md="3">

                      <v-avatar class="ma-3" :style="{ width: '50px', height: '50px' }" tile>

                        <img :src="server_url + 'api/imagenes_base/get_imagenes_base/' + opcion.linkPhoto"
                          style="max-width: 100%; max-height: 100%; object-fit: contain;" />
                      </v-avatar>


                    </v-col>





                    <v-col cols="9" md="9" class="pl-4">


                      <v-card-title class="text-h5"> {{ opcion.descripcion }}</v-card-title>

                      <v-card-subtitle>
                        {{ truncatedObservacion(opcion.observacion) }}
                      </v-card-subtitle>



                      <v-card-actions>
                        <template>
                          <v-btn x-large block style="padding: 5px;" :color="opcion.colorBtn" :href="opcion.link"
                            target="_blank">

                            <v-icon>mdi-open-in-app</v-icon>
                            <v-spacer></v-spacer>
                            OPEN LINK
                            <v-spacer></v-spacer>
                          </v-btn>
                        </template>
                      </v-card-actions>


                    </v-col>



                  </v-row>
                </v-container>
              </template>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>










  </div>










</template>






<script>

import { http } from "@/services/config";
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import principalService from "@/services/principalService.js";

import axios from 'axios';

import router from "@/router/index";


import opcionService from "@/services/opcionService.js";



export default {
  name: 'perfil',

  components: {


  },
  computed: {
    // tab: {
    //   set (tab) {
    //     this.$router.replace({ query: { ...this.$route.query, tab } })
    //   },
    //   get () {
    //     return this.$route.query.tab
    //   }
    // }

    //sortedOpcions() {
    //  return this.opcions.slice().sort((a, b) => a.orden - b.orden);
    //  }
  }

  ,
  data: () => ({
    server_url: "",
    loading: true,
    active: true,
    items: [
      {
        color: '#1F7087',
        src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
        title: 'Supermodel',
        artist: 'Foster the People',
      },
      {
        color: '#952175',
        src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png',
        title: 'Halcyon Days',
        artist: 'Ellie Goulding',
      },
    ],


    principal: {

      id: '',
      nombre: '',
      apellido: '',
      descripcion: '',
      linkPhoto: '',
      color: '',
      observacion: '',
      linkVideo: '',
    },

    opcions: [],
    opcion: {
      id: '',
      descripcion: '',
      link: '',
      linkPhoto: '',
      tipo: '',
      color: '',
      observacion: '',
      linkVideo: '',
    }


  }),

  created() {

  }
  , mounted() {

    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });



    this.server_url = http.defaults.baseURL;



    this.isActive();



  },
  methods: {

    isActive() {

      let idem = this.$route.params.identificador;

      principalService.isActive(idem).then((res) => {


        console.log("Encontrado");

        //IMPLEMENTAR METODO PARA EVALUAR SI ESTA ACTIVO PARA MOSTRAR URL

        this.listarOpcions(this.$route.params.identificador);



      }).catch(e => {

        //console.error(e.response.data.errors);

        console.log("No Encontrado");

        this.active = false;

      })

    },


    listarOpcions(identificador) {
      this.loading = true;
      principalService
        .listarPrincipalsOpcionPorIdentificador(identificador)
        .then((res) => {
          console.log(res.data);
          console.log(res.data.principal);

          this.opcions = res.data.principal.opciones;
          this.principal = res.data.principal;
        }).finally(() => {
          this.loading = false;
        })

    },
    truncatedObservacion(text) {
      const maxLength = 45;
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

  }


}
</script>